<h4>{{ report.section_id }}.{{ report.question_id }} {{ report.title }}</h4>
<div class="row">
  <div class="col" [innerHtml]="report.description"></div>
</div>
<div class="row">
  <div class="col-sm-4">
    <span i18n="Progress">LABEL_PROGRESS</span><br>
    <div class="progress border border-primary">
      <div class="progress-bar"
        role="progressbar" style="width: {{ report.progress }}%;"
        [attr.aria-valuenow]="report.progress"
        [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">{{ report.progress }}%
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <div><span i18n="Risk">LABEL_RISK</span>: {{ report.risk_default_title }}</div>
    <div [innerHtml]="report.risk_description"></div>
    <div *ngIf="report.risk_default_id !== report.risk_id">
      <div><span i18n="Changed from">LABEL_CHANGED_FROM</span>: {{ report.risk_default_title }}</div>
      <div [innerHtml]="report.risk_default_description"></div>
    </div>
  </div>
  <div class="col-sm-4">
    <div><span i18n="Reward">LABEL_REWARD</span>: {{ report.reward_default_title }}</div>
    <div [innerHtml]="report.reward_description"></div>
    <div *ngIf="report.reward_default_id !== report.reward_id">
      <div><span i18n="Changed from">LABEL_CHANGED_FROM</span>: {{ report.reward_default_title }}</div>
      <div [innerHtml]="report.reward_default_description"></div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col" i18n="Your Notes">LABEL_YOUR_NOTES</div>
</div>
<div class="row mb-3">
  <div class="col" [innerHtml]="report.notes"></div>
</div>
